import moment from 'moment'
import React, { FC } from 'react'

import { ReactComponent as ArrowLeft } from '../assets/icons/Arrow-Left.svg'
import { Order } from '../types/order'

interface Props {
    order: Order | null;
    resetOrder: () => void;
}

const Header: FC<Props> = ({ order, resetOrder }) => {
    function getFAQURL() {
        const url = new URL(document.referrer || document.location.href)
        return `${url.origin}/customer-service/faqs`
    }

    return (
        <header className="jd-order-header">
            <div className="jd-order-header__back" onClick={resetOrder}>
                <ArrowLeft/>
                <span>Back</span>
            </div>

            <div className="jd-order-header__title">
                <h1 className="jd-order-header__text">Track my order</h1>
            </div>

            <div className="jd-order-header__subtitle">
                To see the status of your order all you need is your order number and your email
                address or postcode. This is found on your order confirmation or dispatch email
            </div>

            <div className="jd-order-header__message">
                {order !== null && (
                    <>
                        <p>{order.message.text}</p>
                        <p>
                            {order.delivery.trackingURL && (
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={order.delivery.trackingURL}
                                >
                                    Track with courier
                                </a>
                            )}
                        </p>

                        <div className="jd-order-header__chat">
                            <a href={getFAQURL()} rel="noreferrer" target="_blank">
                                Need Help?
                            </a>
                        </div>
                    </>
                )}
            </div>

            <div className="jd-order-header__overview">
                {order !== null && (
                    <>
                        <p>
                            <strong>Order Number:</strong>
                            <span>{order.number}</span>
                        </p>
                        <p>
                            <strong>Order Date:</strong>
                            <span>{moment(order.date).format('DD/MM/YYYY')}</span>
                        </p>
                        <p>
                            <strong>Delivery Type:</strong>
                            <span>{order.delivery.type}</span>
                        </p>
                    </>
                )}
            </div>
        </header>
    )
}

export default Header
